import { useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks";
import { CompanyInformation, GetCompanyInformationResponse } from "@/types";

/**
 * This hook is used to update a company information in the company information
 * query without refetching the entire query.
 */
export const useSetCompanyInformation = () => {
  const currentCompanyId = useCurrentCompanyId();
  const queryClient = useQueryClient();

  return ({
    companyInformation,
  }: {
    companyInformation: CompanyInformation;
  }) => {
    queryClient.setQueryData(
      ["company_information", currentCompanyId],
      (cachedData: GetCompanyInformationResponse) => {
        return {
          ...cachedData,
          companyInformation: {
            ...cachedData.companyInformation,
            ...companyInformation,
          },
        };
      },
    );
  };
};
